import {useEffect, useState} from 'react';

import {Elements} from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';
import {loadStripe} from '@stripe/stripe-js';
import Box from '@mui/material/Box';
import { CTAButton } from '../widget/CTAButton';
import Cookies from 'js-cookie';

function PaymentLoadErrorMessage (){
    return (
		<>
			<Box
				sx={{
					width: "80%",
					marginTop: "60px",
					height: "420px",
					display: "flex",
					justifyContent: "space-between",
					flexDirection: "column",
					alignItems: "center",
				}}
				textAlign="center"
			>

                <p className="purchase-text">There was an error loading the payment service. Please try again later.</p>

			</Box>
		</>
	);
}

function AlreadyPurchasedMessage (){
    return (
		<>
			<Box
				sx={{
					width: "80%",
					marginTop: "60px",
					height: "420px",
					display: "flex",
					justifyContent: "space-between",
					flexDirection: "column",
					alignItems: "center",
				}}
				textAlign="center"
			>
                <p className="purchase-text">You've already purchased this pack!</p>

				<CTAButton CTAButtonText="DOWNLOAD GAME"></CTAButton>
			</Box>
		</>
	);
}

function ContinueToPayment({ onContinue, isLoading }) {
	return (
		<>
			<Box
				sx={{
					width: "80%",
					marginTop: "60px",
					height: "420px",
					display: "flex",
					justifyContent: "space-between",
					flexDirection: "column",
					alignItems: "center",
				}}
				textAlign="center"
			>
				<p className="purchase-text">Ready to complete your purchase?</p>
				<CTAButton
					CTAButtonText={isLoading ? "LOADING..." : "CONTINUE TO PAYMENT"}
					disabled={isLoading}
					onClick={onContinue}
				/>
			</Box>
		</>
	);
}

function Payment() {
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState('');
  const [canPurchase, setCanPurchase] = useState(null);
  const [paymentInitiated, setPaymentInitiated] = useState(false);
  const [isLoadingStripe, setIsLoadingStripe] = useState(false);
  const [stripeLoadError, setStripeLoadError] = useState(false);

  useEffect(() => {
    let email = Cookies.get("DWsessionEmail")
    if(!email){
        setCanPurchase(false);
        return;
    }

    fetch(`/api1/purchaseable/${email}`, {
      method: 'GET',
    }).then(async result => {
        const textResponse = await result.text();
        if(result.status === 200){
            if(textResponse === "Yes"){
                setCanPurchase(true);
            }else{
                setCanPurchase(false);
            }

        }else{
            setCanPurchase(false)
        }
    });
  }, []);

  const handleContinueToPayment = async () => {
    setIsLoadingStripe(true);
    setStripeLoadError(false);

    try {
      const configResponse = await fetch('/api/stripe-config');
      const { publishableKey } = await configResponse.json();

      const intentResponse = await fetch('/api/create-payment-intent', {
        method: 'POST',
        body: JSON.stringify({}),
      });
      const { clientSecret: secret } = await intentResponse.json();

      if (intentResponse.status === 200 && secret) {
        setClientSecret(secret);
        setStripePromise(loadStripe(publishableKey));
        setPaymentInitiated(true);
      } else {
        setStripeLoadError(true);
      }
    } catch {
      setStripeLoadError(true);
    } finally {
      setIsLoadingStripe(false);
    }
  };

  const appearance = {
    theme: 'night',
  };
  const options = {
    clientSecret,
    appearance,
  };

  function DetermineBlockToShow(){
    if (canPurchase === null) {
      return null;
    }

    if (canPurchase === false) {
      return AlreadyPurchasedMessage();
    }

    if (stripeLoadError) {
      return PaymentLoadErrorMessage();
    }

    if (!paymentInitiated) {
      return (
        <ContinueToPayment
          onContinue={handleContinueToPayment}
          isLoading={isLoadingStripe}
        />
      );
    }

    if (clientSecret && stripePromise) {
      return (
        <Elements key={clientSecret} stripe={stripePromise} options={options}>
          <CheckoutForm />
        </Elements>
      );
    }

    return PaymentLoadErrorMessage();
  }

  return (
    <>
      {DetermineBlockToShow()}
    </>
  );
}

export default Payment;
